import { ProviderProvider } from "@RequestFormV2/sections/Provider/context/ProviderProvider";
import DeadlinesSection from "@RequestFormV2/sections/Provider/components/DeadlinesSection";
import ProviderSelectionSection from "@RequestFormV2/sections/Provider/components/ProviderSelectionSection";
import UploadFreightDocumentsSection from "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection";
import { useEditShipmentLock } from "@RequestFormV2/context/editShipmentLock";

function ProviderContent() {
  const isEditShipmentLock = useEditShipmentLock();

  return (
    <>
      <DeadlinesSection />
      {!isEditShipmentLock && <ProviderSelectionSection />}
      <UploadFreightDocumentsSection />
    </>
  );
}

export default function Provider() {
  return (
    <ProviderProvider>
      <ProviderContent />
    </ProviderProvider>
  );
}
